<template>
    <div class="comPractice">
        <component class="commonCom" :is="com[active]" :planInfo="planInfo" @changeActive="changeActive"></component>
    </div>
</template>

<script>
export default {
    name: 'comPractice',

    data() {
        return {
            active: 0,
            com: ['planShow', 'paperDetails', 'insOpenManagement'],
            planInfo: {}
        };
    },

    mounted() {

    },

    methods: {
        changeActive(val, rowData) {
            this.active = val
            this.planInfo = rowData
        }
    },
    components: {
        planShow: () => import('./components/planShow.vue'),
        paperDetails: () => import('./components/paperDetails.vue'),
        insOpenManagement: () => import('./components/insOpenManagement.vue')
    }
};
</script>

<style lang="scss" scoped>
.comPractice {
    width: 100%;
    height: 100%;
}
.commonCom {
    width: 100%;
    height: 100%;
}
</style>